import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sm-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TitleBarComponent implements OnInit {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() pageTitle: string = '';
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input() showBackToDashboard: boolean = false;
  @Input() backWithParams: boolean = false;
  @Input() customBackforbusiness: boolean = false;
  @Input() customBackforemployee: boolean = false;
  @Input() backWithAllParams: boolean = false;
  @Input() backLocation: boolean = false;
  @Input() back: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;


  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
  }
  backButton(){
  this.router.navigate(['../'], {queryParamsHandling: 'preserve', relativeTo: this.route})
  }
  custombackforbusinessf(){
    if(sessionStorage.getItem('bplanslistroute') == 'buy'){
      this.router.navigate(['/business-profile'])
    }
    else if(sessionStorage.getItem('bplanslistroute') == 'renew'){
      const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash, eph: this.route.snapshot.queryParams?.eph  };
      this.router.navigate(['businesses/details/plan-and-renew'], { queryParams });
    }
  }
  custombackforemployeesf(){
    if(sessionStorage.getItem('eplanslistroute') == 'buy' ){
      if(sessionStorage.getItem('currentRouteForNewEmployee') == '2'){
        const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash, eph: this.route.snapshot.queryParams?.eph };
        this.router.navigate(['/businesses/details/employees'],{ queryParams })

      }
      else if(sessionStorage.getItem('currentRouteForNewEmployee') == '1'){
        this.router.navigate(['/all-employees'])
      }
    }
    else if(sessionStorage.getItem('eplanslistroute') == 'renew'){
      const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash, eph: this.route.snapshot.queryParams?.eph };
      this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.route });
    }
  }

  onTitlebarButtonClick(){
    this.onButtonClick.emit(true);
  }

  goToBack(){
    
    this.router.navigate(['dashboard'])
  }

  goToBackWithParams(){
    const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash, eph:this.route.snapshot.queryParams.eph  };
    this.router.navigate(['../'], { queryParams, relativeTo: this.route });
    
  }
  goToBackWithAllParams(){
    // const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash };
    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.route });
    
  }
  goToBackToLocation(){
    // const queryParams = { entityHash: this.route.snapshot.queryParams.entityHash };
    window.history.back()
    
  }

}
